import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faUser, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import UserContext from '../hooks/UserContext'
import { CommonCardStyles } from './styles/Common.js';
import { NO_OP } from '../constants';

const listStyles = css`
${CommonCardStyles}
display: grid;
gap: 10px;
&.owner {
  grid-template-columns: 1fr 0.33fr 0.33fr 0.33fr;
  grid-template-areas: 'name people groups ideas';
}
&.friend {
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'name shared-by';
}
&.header {
  //font-weight: bold;
}
& .name {
   grid-area: name;
}

& .people {
    grid-area: people;
    display: flex;
    flex-direction: row;
    gap:4px;
  }

& .groups {
    grid-area: groups;
    display: flex;
    flex-direction: row;
    gap:5px;
  }

  & .ideas {
    grid-area: ideas;
    display: flex;
    flex-direction: row;
    gap:5px;
  }

& .shared-by {
  display: flex;
  flex-direction: column;
  grid-area: shared-by;
  text-align: left;

  .email {
    font-size: .75em;
  }
}
`
const ListCard = styled(({ className, item: list, onSelectItem = {NO_OP}}) => {
  const { user } = useContext(UserContext);
  const isOwner = user._id === list?.user?._id;
    return (
      <div className={`${className} ${isOwner ? 'owner' : 'friend'}`} onClick = {() => onSelectItem(list)}>
        <div className='name'>
          {list.name}
        </div>
        {isOwner
          ? <>
            <div className='people'>
              <span>{list.sharedWith.users.length}</span>
              <span className='icon'><FontAwesomeIcon icon={faUser} /></span>
            </div>
            <div className='groups'>
              <span>{list.sharedWith.groups.length}</span>
              <span className='icon'><FontAwesomeIcon icon={faUserFriends} /></span>
            </div>
            <div className='ideas'>
              <span>{list.itemCount}</span>
              <span className='icon'><FontAwesomeIcon icon={faGift} /></span>
            </div>
          </>
          : <div className='shared-by'>
            <div className='user-name'>{`${list.user.firstname} ${list.user.lastname}`}</div>
            <div className='email'>{list.user.email}</div>
          </div>
        }
      </div>
    )
})`${listStyles}`;

export default ListCard;